import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";
import { toast } from "react-toastify";

import api from "../../services/api";
import ButtonWithSpinner from "../ButtonWithSpinner";
import toastError from "../../errors/toastError";

const ForwardMessageModal = ({ modalOpen, onClose, message }) => {
  const history = useHistory();
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchParam, setSearchParam] = useState("");
  const [selectedContact, setSelectedContact] = useState(null);

  useEffect(() => {
    if (!modalOpen || searchParam.length < 3) {
      setLoading(false);
      return;
    }
    setLoading(true);
    const delay = setTimeout(async () => {
      try {
        const { data } = await api.get("contacts", { params: { searchParam } });
        setOptions(data.contacts || []);
      } catch (err) {
        toastError(err);
      }
      setLoading(false);
    }, 500);
    return () => clearTimeout(delay);
  }, [searchParam, modalOpen]);

  const handleClose = () => {
    onClose();
    setSearchParam("");
    setSelectedContact(null);
    setOptions([]);
    setLoading(false);
  };

  const handleForward = async () => {
    if (!selectedContact?.id || !message?.id) return;
    setLoading(true);
    try {
      const { data } = await api.post(`/messages/${message.id}/forward`, {
        contactId: selectedContact.id,
      });
      toast.success("Mensagem encaminhada!");
      handleClose();
      if (data?.ticketId) history.push(`/tickets/${data.ticketId}`);
    } catch (err) {
      toastError(err);
      setLoading(false);
    }
  };

  return (
    <Dialog open={modalOpen} onClose={handleClose}>
      <DialogTitle>Encaminhar mensagem</DialogTitle>
      <DialogContent dividers>
        <Autocomplete
          options={options}
          loading={loading}
          style={{ width: 320 }}
          clearOnBlur
          autoHighlight
          clearOnEscape
          getOptionLabel={o => (o?.number ? `${o.name} - ${o.number}` : "")}
          renderOption={o => `${o.name} - ${o.number}`}
          onChange={(e, v) => setSelectedContact(v && v.number ? v : null)}
          renderInput={params => (
            <TextField
              {...params}
              label="Buscar contato de destino"
              variant="outlined"
              autoFocus
              onChange={e => setSearchParam(e.target.value)}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {loading ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              }}
            />
          )}
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleClose}
          color="secondary"
          disabled={loading}
          variant="outlined"
        >
          Cancelar
        </Button>
        <ButtonWithSpinner
          variant="contained"
          type="button"
          disabled={!selectedContact}
          onClick={handleForward}
          color="primary"
          loading={loading}
        >
          Encaminhar
        </ButtonWithSpinner>
      </DialogActions>
    </Dialog>
  );
};

export default ForwardMessageModal;
